import React from 'react';
import PropTypes from 'prop-types';
import useMobile from '../useMobile';

function getImage(year = '2022') {
  switch (year) {
    case '2023':
      return 'https://cdn.shopify.com/s/files/1/0051/6295/8946/files/domino_badge_2023.png?v=1700521927';
    default:
      return 'https://cdn.shopify.com/s/files/1/0051/6295/8946/files/domino_badge.png?v=1670978851';
  }
}

const BestWallpaperBadge = (props) => {
  const isMobile = useMobile();
  const imageUrl = getImage(props.year);
  return (
    <img
      {...props}
      alt={`domino: Best Wallpaper of ${props.year ?? 2022}`}
      title={`domino: Best Wallpaper of ${props.year ?? 2022}`}
      src={imageUrl}
      style={{
        width: isMobile ? '60px' : 'auto',
      }}
    />
  );
};

BestWallpaperBadge.propTypes = {
  year: PropTypes.string,
};

export default BestWallpaperBadge;
